export const HamburgerMenu = "hamburger_menu";
export const HardLink = "hard_link";
export const HardLinkPosties = "hard_link_posties";
export const Inline = "inline";
export const InlineAuto = "inline_auto";
export const InlinePosties = "inline_posties";
export const Masthead = "masthead";
export const MegaMenuKnowledgeCard = "mega_menu_knowledge_card";
export const MyAccountOverlay = "my_account_overlay";
export const SCMPFavouritesLink = "scmp_favourites_link";
